
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/termeni-si-conditii",
      function () {
        return require("private-next-pages/info/termeni-si-conditii.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/termeni-si-conditii"])
      });
    }
  